export const announce = {
    quantity: "จำนวน",
    reward: "รางวัล",
    name_title: "คุณ",
    announce_tile: 'ประกาศรายชื่อผู้โชคดี',
    activity: 'กิจกรรม',
    prize: 'ลุ้นรับรางวัล'
}